import { SvgHelper } from 'markerjs2';

/**
 * Represents a single resize-manipulation grip used in marker's manipulation controls.
 */
export class SmallResizeGrip {
  /**
   * Grip's visual element.
   */
  visual = null;

  /**
   * Grip's size (raduis).
   */
  GRIP_SIZE = 3;

  /**
   * Creates a new grip.
   */
  constructor(color) {
    this.visual = SvgHelper.createGroup();
    this.visual.appendChild(
      SvgHelper.createCircle(this.GRIP_SIZE * 1.5, [['fill', 'transparent']])
    );
    this.visual.appendChild(
      SvgHelper.createCircle(this.GRIP_SIZE, [
        ['fill', color],
        ['stroke', 'black'],
        ['stroke-width', '0.5'],
      ])
    );
  }

  /**
   * Returns true if passed SVG element belongs to the grip. False otherwise.
   *
   * @param el - target element.
   */
  ownsTarget(el) {
    if (
      el === this.visual ||
      el === this.visual.childNodes[0] ||
      el === this.visual.childNodes[1]
    ) {
      return true;
    } else {
      return false;
    }
  }
}
